import { UseMutationOptions } from '@tanstack/react-query';

import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

export type InconnectVariantInput = {
    language: string; // 'en-us' | 'es-cr'
    htmlContent: string;
    subjectLine?: string;
};

export type ExecuteInconnectImportInput = {
    inconnectTemplateId: number;
    tagMapping: Record<string, string>;
    templateName: string;
    variants: InconnectVariantInput[];
    conversionMode?: 'html' | 'native';
    assessmentId?: string;
    assessmentName?: string;
    assessmentConsentRequired?: boolean;
};

const useExecuteInconnectImport = (mutateOptions?: UseMutationOptions<unknown, Error, ExecuteInconnectImportInput>) =>
    useMutation<ExecuteInconnectImportInput>(
        MutationKeys.EXECUTE_INCONNECT_IMPORT,
        CuredApiPaths.INCONNECT_IMPORT,
        mutateOptions
    );

export default useExecuteInconnectImport;
